import { submitChatLead } from '../services/chatLeadService';
// src/components/ContactUs.js
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './ContactUs.css';
import HoneypotField, { isHoneypotSubmission } from './HoneypotField';

const ContactUs = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    postalCode: '',
    serviceReq: 'buying'
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    const tryPlay = () => video.play().catch(() => {});
    if (video.readyState >= 2) tryPlay();
    else video.addEventListener('loadeddata', tryPlay, { once: true });
    return () => video.removeEventListener('loadeddata', tryPlay);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isHoneypotSubmission(e.currentTarget)) {
      setSuccess(true);
      setFormData({ name: '', email: '', phoneNumber: '', postalCode: '', serviceReq: 'buying' });
      setTimeout(() => setSuccess(false), 5000);
      return;
    }

    setSubmitting(true);
    try {
      const params = new URLSearchParams({
        postalCode: formData.postalCode,
        name: formData.name,
        phoneNumber: formData.phoneNumber,
        serviceReq: formData.serviceReq,
        email: formData.email,
        siteId: SITE_CONFIG.SITE_ID
      });
      const response = await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?${params}`).searchParams, { rememberContact: true });
      if (response.ok) {
        setSuccess(true);
        setFormData({ name: '', email: '', phoneNumber: '', postalCode: '', serviceReq: 'buying' });
        setTimeout(() => setSuccess(false), 5000);
      } else {
        alert('Failed to submit. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-premium">
      <video
        ref={videoRef}
        className="contact-premium-video"
        autoPlay
        muted
        loop
        playsInline
        poster="https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/maricopa-contactus.jpg"
      >
        <source src="https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/maricopa-contactus.mp4" type="video/mp4" />
      </video>
      <div className="contact-premium-overlay" />

      <button className="contact-premium-back" onClick={() => navigate('/')} aria-label="Back to home">
        ← Back
      </button>

      <div className="contact-premium-layout">
        <div className="contact-premium-hero">
          <div className="contact-premium-badge">THE BEST IN MARICOPA & MORE</div>
          <h1>{SITE_CONFIG.AGENT.NAME}</h1>
          <p className="contact-premium-brokerage">{SITE_CONFIG.AGENT.BROKERAGE_NAME}</p>
          <p className="contact-premium-tagline">
            Your trusted real estate expert in Maricopa, AZ.<br />
            Dedicated to exceptional results.
          </p>
          <div className="contact-premium-credentials">
            <div className="contact-premium-cred">
              <span className="cred-label">License</span>
              <span className="cred-value">{SITE_CONFIG.AGENT.LICENSE}</span>
            </div>
            <div className="contact-premium-cred">
              <span className="cred-label">Phone</span>
              <span className="cred-value">{SITE_CONFIG.AGENT.PHONE}</span>
            </div>
            <div className="contact-premium-cred">
              <span className="cred-label">Email</span>
              <span className="cred-value">{SITE_CONFIG.AGENT.EMAIL}</span>
            </div>
          </div>
        </div>

        <div className="contact-premium-form-card">
          <h2>Let's Connect</h2>
          <p className="contact-premium-form-sub">Tell me about your real estate goals</p>
          {success && (
            <div className="contact-premium-success">
              ✓ Thank you! I'll be in touch shortly.
            </div>
          )}
          <form onSubmit={handleSubmit}>
          <HoneypotField />
            <input
              type="text"
              placeholder="Full Name"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
              aria-label="Full Name"
            />
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
              aria-label="Email"
            />
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
              required
              aria-label="Phone Number"
            />
            <input
              type="text"
              placeholder="ZIP Code"
              value={formData.postalCode}
              onChange={(e) => setFormData({...formData, postalCode: e.target.value})}
              required
              aria-label="ZIP Code"
            />
            <select
              value={formData.serviceReq}
              onChange={(e) => setFormData({...formData, serviceReq: e.target.value})}
              required
              aria-label="Service type"
            >
              <option value="buying">I'm Buying</option>
              <option value="selling">I'm Selling</option>
              <option value="both">Buying & Selling</option>
            </select>
            <button type="submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Get Started'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
